import { AxiosResponse } from 'axios';
import { notificationCreate, notificationDelete, notificationList, notificationUpdate } from '@/api/notification';
import { AppError } from '@/errors/appError';
import type { NotificationItem } from '@/models/notification';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { INotificationApiListResponse, INotificationFilters, INotificationMutationResponse, INotificationUpdateParams } from '@/types/notification';

export const notificationService = {
    async list(params: IListParams<INotificationFilters>): Promise<AxiosResponse<INotificationApiListResponse>> {
        try {
            return await baseListService<INotificationApiListResponse>(notificationList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Notification API Error:', e);
            throw new AppError('Unable to load notification list, request error', { cause: e });
        }
    },

    async save(item: NotificationItem): Promise<AxiosResponse<INotificationMutationResponse>> {
        const row = item.toApiData();
        if (item.id > 0) {
            return this.update({ rows: [row] });
        }
        return this.create({ rows: [row] });
    },

    async create(params: INotificationUpdateParams): Promise<AxiosResponse<INotificationMutationResponse>> {
        try {
            return await notificationCreate(params);
        } catch (e) {
            console.error('Notification create API Error:', e);
            throw new AppError('Unable to create notification, request error', { cause: e });
        }
    },

    async update(params: INotificationUpdateParams): Promise<AxiosResponse<INotificationMutationResponse>> {
        try {
            return await notificationUpdate(params);
        } catch (e) {
            console.error('Notification update API Error:', e);
            throw new AppError('Unable to update notification, request error', { cause: e });
        }
    },

    async delete(id: number): Promise<AxiosResponse<INotificationMutationResponse>> {
        try {
            return await notificationDelete({ rows: [{ id }] });
        } catch (e) {
            console.error('Notification delete API Error:', e);
            throw new AppError('Unable to delete notification, request error', { cause: e });
        }
    },
};
